export const HEADERS = [
  'HEADER.ID',
  'HEADER.NAME',
  'HEADER.FIRST_SURNAME',
  'HEADER.LAST_SURNAME',
  'HEADER.EMAIL',
  'HEADER.PERCENTAGE',
  'HEADER.CREATED',
];
